<template>
  <div>
    <v-autocomplete
      :items="categorias"
      :loading="loading"
      :search-input.sync="search"
      item-text="categoria"
      item-value="id"
      label="Categoria Estabelecimento"
      hide-no-data
      hide-selected
      return-object
      v-model="model"
      @change="selecionarCategoriaEstabelecimento"
    />
    <v-chip 
      v-for="c in categoriasSelecionadas"
      :key="c.id"
      close
      @input="removerCategoriaSelecionada(c.id)"
    >{{ c.categoria }}</v-chip>
  </div>
</template>

<script>
import api from '../../api'

export default {
  name: 'FiltroCategoriaEstabelecimento',
  data() {
    const categoriasInitial = [
      {
        id: null,
        categoria: 'Todas as categorias'
      }
    ]
    return {
      categoriasInitial,
      categorias: categoriasInitial,
      categoriasSelecionadas: [],
      model: null,
      loading: false,
      buscador: null,
      search: null,
      selected: false
    }
  },
  watch: {
    search() {
      if (this.search === 'Todas as categorias') {
        return
      }
      if (this.selected) {
        this.selected = false
        return
      }
      if (this.buscador !== null) {
        clearTimeout(this.buscador)
      }
      this.buscador = setTimeout(this.buscarCategorias, 1000)
    },
  },
  methods: {
    async buscarCategorias() {
      let categorias
      try {
        this.loading = true
        this.categorias = this.categoriasInitial
        const response = await api.post('/', {
          query: `{ categoriasEstabelecimento(categoria: "${this.search}") { id categoria } }`
        })
        categorias = response.data.data.categoriasEstabelecimento
      }
      catch {
        categorias = []
      }
      finally {
        this.categorias = this.categorias.concat(categorias)
        this.loading = false
      }
    },
    selecionarCategoriaEstabelecimento(value) {
      if (value === undefined) {
        return
      }
      else if (value.id === null) {
        this.categoriasSelecionadas = this.categoriasInitial
      }
      else {
        if (this.categoriasSelecionadas.length > 0 && this.categoriasSelecionadas[0].id === null) {
          this.categoriasSelecionadas = []
        }
        this.categoriasSelecionadas.push(value)
      }
      this.emitirCategoriasSelecionadas()
      this.selected = true
    },
    removerCategoriaSelecionada(id) {
      if (id === null) {
        return
      }
      this.categoriasSelecionadas = this.categoriasSelecionadas.filter(e => e.id !== id)
      this.emitirCategoriasSelecionadas()
    },
    emitirCategoriasSelecionadas() {
      let lista = this.categoriasSelecionadas.slice()
      if (lista.length > 0 && lista[0].id === null) {
        lista.splice(0, 1)
      }
      let retorno = []
      for (let i = 0; i < lista.length; i ++) {
        retorno.push(lista[i].id);
      }
      this.$emit('filtrar-categorias-estabelecimento', { 
        categorias_estabelecimento: retorno 
      })
    }
  }
}
</script>
